import firebase from "config/firebase";
import { toast } from "react-toastify";
import axios from "axios";

export const fetchInstitutes = () => async (dispatch) => {
  firebase
    .firestore()
    .collection("institution")
    .onSnapshot((query) => {
      var tempInstitutes = [];
      query.forEach((doc) => {
        tempInstitutes.push({ id: doc.id, ...doc.data() });
      });
      dispatch({
        type: "GET_INSTITUTES",
        payload: tempInstitutes
      });
    });
};
export const deleteIssue =
  (id, onComplete = () => {}) =>
  async (dispatch) => {
    firebase
      .firestore()
      .collection("complaints")
      .doc(id)
      .delete()
      .then((res) => {
        dispatch({
          type: "DELETE_ISSUE",
          payload: id
        });
        toast.success("Issue Deleted Successfully");
        onComplete();
      });
  };
export const updateIssue = (id, status) => {
  return async (dispatch) => {
    firebase
      .firestore()
      .collection("complaints")
      .doc(id)
      .update({ status: status })
      .then((res) => {
        dispatch({
          type: "UPDATE_ISSUE",
          payload: { id, status }
        });
        toast.success(`Issue ${status}`);
      });
  };
};
export const getPlayerIssues = (id, lastDocument, onComplete = () => {}) => {
  return async (dispatch) => {
    let query = firebase
      .firestore()
      .collection("complaints")
      .where("issue_from", "==", "Player");

    if (id) {
      query = query.where("issue_id", "==", id);
    }
    if (lastDocument) {
      query = query.orderBy("created_at", "desc").startAfter(lastDocument);
    }
    query = query.limit(5);
    const unsubscribe = query.onSnapshot(async (snapshot) => {
      var issues = [];
      for await (let doc of snapshot.docs) {
        let userDoc = await firebase
          .firestore()
          .collection("users")
          .doc(doc.data().issue_by)
          .get();
        issues.push({
          id: doc.id,
          ...doc.data(),
          name: userDoc.exists
            ? `${userDoc.data().first_name} ${userDoc.data().last_name}`
            : "Unknown User",
          ...userDoc.data()
        });
      }
      dispatch({
        type: lastDocument ? "MORE_GET_PLAYER_ISSUES" : "GET_PLAYER_ISSUES",
        payload: {
          data: issues,
          lastDocument: snapshot.docs[issues.length - 1] || null,
          hasMoreDocument: issues.length >= 5
        }
      });
      onComplete();
    });
    return unsubscribe;
  };
};

export const getUserIssues = (id, lastDocument, onComplete = () => {}) => {
  return async (dispatch) => {
    let query = firebase
      .firestore()
      .collection("complaints")
      .where("issue_from", "==", "User")
      .orderBy("created_at", "desc");

    if (id) {
      query = query.where("issue_id", "==", id);
    }
    if (lastDocument) {
      query = query.orderBy("created_at", "desc").startAfter(lastDocument);
    }
    query = query.limit(5);
    const unsubscribe = query.onSnapshot(async (snapshot) => {
      var issues = [];
      for await (let doc of snapshot.docs) {
        let userDoc = await firebase
          .firestore()
          .collection("users")
          .doc(doc.data().issue_by)
          .get();

        issues.push({
          id: doc.id,
          ...doc.data(),
          ...userDoc.data()
        });
      }
      dispatch({
        type: lastDocument ? "MORE_GET_USER_ISSUES" : "GET_USER_ISSUES",
        payload: {
          data: issues,
          lastDocument: snapshot.docs[issues.length - 1] || null,
          hasMoreDocument: issues.length >= 5
        }
      });
      onComplete();
    });
    return unsubscribe;
  };
};

export const getChatRefundRequests = () => {
  return async (dispatch) => {
    firebase
      .firestore()
      .collection("a4b_chat_refund")
      .onSnapshot(async (query) => {
        var requests = [];
        for await (let doc of query.docs) {
          let athlete = await firebase
            .firestore()
            .collection("users")
            .doc(doc.data().athlete_id)
            .get();
          let fan = await firebase
            .firestore()
            .collection("users")
            .doc(doc.data().fan_id)
            .get();
          let chat = await firebase
            .firestore()
            .collection("a4b_chat")
            .doc(doc.data().chat_id)
            .get();
          requests.push({
            id: doc.id,
            fan: fan.data(),
            athlete: athlete.data(),
            payment_id: chat.data().payment_id,
            chat_amount: chat.data().paid_amount.value,
            ...doc.data()
          });
        }
        dispatch({
          type: "GET_A4B_CHAT_REFUND_REQUESTS",
          payload: requests
        });
      });
  };
};

export const getAllChatsById = (id) => async (dispatch) => {
  firebase
    .firestore()
    .collection("a4b_chat")
    .where("participants", "array-contains", id)
    .orderBy("created_at", "desc")
    .onSnapshot(async (query) => {
      var tempChat = [];
      for await (let doc of query.docs) {
        var unReadMsg = [];
        let participant = doc.data().participants.find((ele) => ele != id);
        let userRef = await firebase
          .firestore()
          .collection("users")
          .doc(participant)
          .get();
        let newMessage = await firebase
          .firestore()
          .collection("a4b_chat")
          .doc(doc.id)
          .collection("messages")
          .where("read", "==", false)
          .where("sender_id", "!=", id)
          .get();
        newMessage.docs.forEach((doc) => {
          unReadMsg.push(doc.data());
        });
        tempChat.push({
          chatUser: userRef.data(),
          unreadMsg: unReadMsg,
          partId: participant,
          id: doc.id,
          ...doc.data()
        });
      }
      dispatch({
        type: "GET_ALL_CHAT_BY_ID",
        payload: tempChat
      });
    });
};

export const getMessageById = (id) => async (dispatch) => {
  let unSub = firebase
    .firestore()
    .collection("a4b_chat")
    .doc(id)
    .collection("messages")
    .orderBy("created_at", "asc")
    .onSnapshot((query) => {
      var tempMSg = [];
      query.forEach((doc) => {
        tempMSg.push({ id: doc.id, ...doc.data() });
      });
      dispatch({
        type: "GET_ALL_MESSAGES_BY_ID",
        payload: tempMSg
      });
    });
  dispatch({
    type: "SET_UNSUB",
    payload: unSub
  });
};
export const allMessageRead = (id) => async (dispatch) => {
  let tempChat = [];
  let messages = await firebase
    .firestore()
    .collection("a4b_chat")
    .doc(id)
    .collection("messages")
    .get();
  messages.forEach((msg) => {
    tempChat.push({ id: msg.id, ...msg.data() });
  });
  for await (let doc of tempChat) {
    firebase
      .firestore()
      .collection("a4b_chat")
      .doc(id)
      .collection("messages")
      .doc(doc.id)
      .update({ read: true });
  }
};

export function refundPayment(id, order_id) {
  return async (dispatch) => {
    await dispatch(generalLoader(true));
    const url =
      `${process.env.REACT_APP_FIREBASE_BASE_DOMAIN}/refundPayment`;
    const response = await axios.post(url, {
      order_id
    });
    if (response.data.status == "COMPLETED") {
      firebase
        .firestore()
        .collection("a4b_chat_refund")
        .doc(id)
        .update({ status: "COMPLETED" });
      toast.success("The payment has been fully refunded successfully");
    } else {
      toast.error("The payment has already been fully refunded");
    }
    await dispatch(generalLoader(false));
  };
}
export const generalLoader = (val) => async (dispatch) => {
  dispatch({
    type: "GENERAL_LOADER",
    payload: val
  });
};

export const getA4BSuggestions = (
  lastDocA4bSuggestions = null,
  onSuccess = () => {}
) => {
  return async (dispatch) => {
    dispatch({ type: "FETCH_A4B_SUGGESTIONS_PENDING" });
    try {
      const a4bSuggestionsCollectionRef = firebase
        .firestore()
        .collection("a4b_suggestion");
      const a4bSuggestionsLimit = 5;

      let q = a4bSuggestionsCollectionRef
        .orderBy("created_at", "desc")
        .limit(a4bSuggestionsLimit);

      if (lastDocA4bSuggestions) {
        q = q.startAfter(lastDocA4bSuggestions);
      }
      const querySnapshot = await q.get();
      // const unsubscribe = q.onSnapshot((querySnapshot) => {
      const a4bSuggestions = [];
      let lastVisible = null;

      querySnapshot.forEach((doc) => {
        a4bSuggestions.push({ id: doc.id, ...doc.data() });
        lastVisible = doc;
      });

      const hasMoreA4bSuggestions = querySnapshot.size >= a4bSuggestionsLimit;

      dispatch({
        type: lastDocA4bSuggestions
          ? "FETCH_A4B_SUGGESTIONS_LOAD_MORE_SUCCESS"
          : "FETCH_A4B_SUGGESTIONS_SUCCESS",
        payload: {
          a4bSuggestions,
          lastDocA4bSuggestions: lastVisible,
          hasMoreA4bSuggestions
        }
      });

      onSuccess();
      // });

      // return unsubscribe;
    } catch (error) {
      console.error("Error fetching orders:", error.message);
      dispatch({
        type: "FETCH_A4B_SUGGESTIONS_REJECTED",
        errorA4bSuggestions: error.message
      });
      onSuccess();
    }
  };
};

export const getA4BAllChats = () => async (dispatch) => {
  await dispatch(generalLoader(true));
  await firebase
    .firestore()
    .collection("new_a4b_chat")
    .orderBy("created_at", "desc")
    .onSnapshot(async (query) => {
      var tempChat = [];
      for await (let doc of query.docs) {
        let athleteRef = await firebase
          .firestore()
          .collection("users")
          .doc(doc.data().participants[0])
          .get();
        let fanRef = await firebase
          .firestore()
          .collection("users")
          .doc(doc.data().participants[1])
          .get();
        tempChat.push({
          athlete: athleteRef.data(),
          fan: fanRef.data(),
          id: doc.id,
          ...doc.data()
        });
      }
      dispatch({
        type: "GET_ALL_CHATS",
        payload: tempChat
      });
      await dispatch(generalLoader(false));
    });
};

export const getIssuesStats =
  (onComplete = () => {}) =>
  (dispatch) => {
    firebase
      .firestore()
      .collection("stats")
      .doc("issues")
      .onSnapshot(async (query) => {
        dispatch({
          type: "GET_ISSUES_STATS",
          payload: query.data()
        });
        onComplete();
      });
  };
